import React, { useRef, useEffect, useState, useMemo } from 'react';
import { useQuery } from 'react-query';
import { Card } from 'react-bootstrap';
import * as moment from 'moment';
import $ from 'jquery';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import SmallBox from '../components/small-box/SmallBox';
import {
    POST_API,
    ACCOUNT_API,
    WEB_ANALYSIS,
    LOG_API,
    LOGIN_HISTORY_API,
    ADVERTISING_ANALYSIS_API,
    BAOCAO_API
    // ACCOUNTHIS_API
} from '../utils/apiUrl.js';
import { Get } from '../utils/httpProvider';
// import ListPost from './post/ListPost';
import {
    postStatus,
    reportPost,
    objectStatusPost,
    rangeDate,
    rangeDateReport,
    styleSelectDefault,
    rangeDateDashboardNotHaveDate,
    objectDoctorEvaluationStatus,
    role
} from '../utils/define';
import { getDateTimeISOString, dateTimeToStringRequest } from '../utils/helper';
import { AsyncPaginate } from 'react-select-async-paginate';
import Plotly from 'plotly.js-basic-dist';
import createPlotlyComponent from 'react-plotly.js/factory';
import locale from 'plotly.js-locales/vi';
import AccountPatient from '@app/pages/accountPatient/AccountPatient';
const Plot = createPlotlyComponent(Plotly);
Plotly.register(locale);
Plotly.setPlotConfig({ locale: 'vi' });

const Dashboard = () => {
    const refBaocao = useRef(null);
    const [activeTab, setActiveTab] = useState(postStatus.all);
    const [chieucao, setChieucao] = useState(0);
    const [accountPatientId, setAccountPatientId] = useState('');
    // const [displayBy, setDisplayBy] = useState('date');
    const [displayBy, setDisplayBy] = useState('week');
    const [displayByCancel, setDisplayByCancel] = useState('week');
    const [displayByBaoHiem, setDisplayByBaoHiem] = useState('week');
    const [displayByMethod, setDisplayByMethod] = useState('week');
    const [displayBySoTienVaDonVi, setDisplayBySoTienVaDonVi] =
        useState('week');
    const [displayByHMSFeeTraLai, setDisplayByHMSFeeTraLai] = useState('week');

    const combineAndAggregateData = (phanMemData, duLieuBenhVienData, key) => {
        const aggregated = {};

        // Combine and aggregate data
        [...phanMemData, ...duLieuBenhVienData].forEach((item) => {
            const name = item[key];
            if (!aggregated[name]) {
                aggregated[name] = 0;
            }
            aggregated[name] += item.tanSuat;
        });

        return aggregated;
    };

    const sanitizeHtml = (htmlString) => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlString;
        return tempDiv.textContent || tempDiv.innerText || ''; // Extract text content
    };

    const formatNumber = (num) => {
        if (Math.abs(num) >= 1.0e9) {
            return (num / 1.0e9).toFixed(1) + 'B'; // Billion
        } else if (Math.abs(num) >= 1.0e6) {
            return (num / 1.0e6).toFixed(1) + 'M'; // Million
        } else if (Math.abs(num) >= 1.0e3) {
            return (num / 1.0e3).toFixed(1) + 'K'; // Thousand
        } else {
            return num.toFixed(1); // Original number
        }
    };

    const [monthNames, setMonthNames] = useState([
        'Tháng 1',
        'Tháng 2',
        'Tháng 3',
        'Tháng 4',
        'Tháng 5',
        'Tháng 6',
        'Tháng 7',
        'Tháng 8',
        'Tháng 9',
        'Tháng 10',
        'Tháng 11',
        'Tháng 12'
    ]);

    const timeCurentDay = moment().subtract(3, 'months');
    timeCurentDay.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });

    const [datesMethodDonut, setDatesMethodDonut] = useState({
        startDate: timeCurentDay,
        endDate: moment()
    });

    const [datesMethodLine, setDatesMethodLine] = useState({
        startDate: timeCurentDay,
        endDate: moment()
    });

    // Thống kê số lượng method
    const statisticsDoctorEvaluationDonut = useQuery(
        ['statisticsDoctorEvaluationDonut'],
        () => {
            let model = {};

            if (datesMethodDonut && datesMethodDonut.startDate) {
                model.ThoiGianBaoCaoBatDau =
                    datesMethodDonut.startDate._d.toISOString();
            }

            if (datesMethodDonut && datesMethodDonut.endDate) {
                model.ThoiGianBaoCaoKetThuc =
                    datesMethodDonut.endDate._d.toISOString();
            }

            return Get(BAOCAO_API.GET_BAOCAO_DANHGIA_DONUT, null, model);
        }
    );

    // Thống kê số lượng method
    const statisticsPatientByDay = useQuery(['statisticsPatientByDay'], () => {
        let model = {
            AccountPatientId: accountPatientId.target.value.value
        };

        if (datesMethodDonut && datesMethodDonut.startDate) {
            model.ThoiGianBaoCaoBatDau =
                datesMethodDonut.startDate._d.toISOString();
        }

        if (datesMethodDonut && datesMethodDonut.endDate) {
            model.ThoiGianBaoCaoKetThuc =
                datesMethodDonut.endDate._d.toISOString();
        }

        return Get(
            BAOCAO_API.GET_BAOCAO_LUONGTAP_BENHNHANH_THEONGAY,
            null,
            model
        );
    });

    // Số lượng báo cáo
    // const countReport = useQuery(['countReportData'], () => {
    //     return Get(BAOCAO_API.GET_BAOCAO_SOLUONG, null, {
    //         AccountHisId:
    //             accountPatientId &&
    //             accountPatientId.target &&
    //             accountPatientId.target.value
    //                 ? accountPatientId.target.value.value
    //                 : ''
    //     });
    // });

    useEffect(() => {
        statisticsDoctorEvaluationDonut.refetch();
    }, [datesMethodDonut]);

    useEffect(() => {
        statisticsPatientByDay.refetch();
    }, [datesMethodDonut, accountPatientId]);

    // useEffect(() => {
    //     countReport.refetch();
    // }, [accountPatientId]);

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    // useEffect(() => {
    //     window.addEventListener('resize', resizeWindow);
    //     return () => window.removeEventListener('resize', resizeWindow);
    // }, []);

    const isMobile = () => {
        return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    };

    const aggregateDataByWeekMethod = (data) => {
        const groupedData = {};

        // Group data by week
        data.forEach((point) => {
            const weekStart = moment(point.date)
                .startOf('week')
                .format('YYYY-MM-DD');
            if (!groupedData[weekStart]) {
                groupedData[weekStart] = { totalUpdate: 0, totalDelete: 0 };
            }
            groupedData[weekStart].totalUpdate += point.totalUpdate;
            groupedData[weekStart].totalDelete += point.totalDelete;
        });

        // Calculate date range
        const dates = data.map((point) => new Date(point.date));
        const minDate = moment(Math.min(...dates)).startOf('week');
        const maxDate = moment(Math.max(...dates)).startOf('week');

        // Generate all weeks within the range
        const allWeeks = [];
        let currentWeek = minDate;
        while (currentWeek <= maxDate) {
            allWeeks.push(currentWeek.format('YYYY-MM-DD'));
            currentWeek.add(1, 'week');
        }

        // Ensure every week has values
        const xValues = allWeeks;
        const totalUpdateValues = xValues.map((week) =>
            groupedData[week] ? groupedData[week].totalUpdate : 0
        );
        const totalDeleteValues = xValues.map((week) =>
            groupedData[week] ? groupedData[week].totalDelete : 0
        );

        return { xValues, totalUpdateValues, totalDeleteValues };
    };

    const aggregateDataByMonthMethod = (data) => {
        const groupedData = {};

        // Group data by month
        data.forEach((point) => {
            const monthStart = moment(point.date)
                .startOf('month')
                .format('YYYY-MM-DD');
            if (!groupedData[monthStart]) {
                groupedData[monthStart] = { totalUpdate: 0, totalDelete: 0 };
            }
            groupedData[monthStart].totalUpdate += point.totalUpdate;
            groupedData[monthStart].totalDelete += point.totalDelete;
        });

        // Calculate date range
        const dates = data.map((point) => new Date(point.date));
        const minDate = moment(Math.min(...dates)).startOf('month');
        const maxDate = moment(Math.max(...dates)).startOf('month');

        // Generate all months within the range
        const allMonths = [];
        let currentMonth = minDate;
        while (currentMonth <= maxDate) {
            allMonths.push(currentMonth.format('YYYY-MM-DD'));
            currentMonth.add(1, 'month');
        }

        // Ensure every month has values
        const xValues = allMonths;
        const totalUpdateValues = xValues.map((month) =>
            groupedData[month] ? groupedData[month].totalUpdate : 0
        );
        const totalDeleteValues = xValues.map((month) =>
            groupedData[month] ? groupedData[month].totalDelete : 0
        );

        return { xValues, totalUpdateValues, totalDeleteValues };
    };

    const plotRef = useRef(null);

    useEffect(() => {
        if (
            plotRef.current &&
            statisticsDoctorEvaluationDonut &&
            statisticsDoctorEvaluationDonut.data
        ) {
            const values = statisticsDoctorEvaluationDonut.data.map(
                (x) => x.count ?? 0
            );
            const labels = statisticsDoctorEvaluationDonut.data.map(
                (x) =>
                    objectDoctorEvaluationStatus.find(
                        (status) => status.value === x.evaluationStatus
                    )?.label || 'Chưa đánh giá'
            );

            const layout = {
                title: 'Tỉ lệ Đánh giá bác sĩ',
                annotations: [
                    {
                        font: { size: 20 },
                        showarrow: false,
                        text: 'Đánh<br>giá',
                        x: 0.5,
                        y: 0.5
                    }
                ],
                showlegend: true,
                legend: {
                    orientation: 'h',
                    font: { size: 12, color: 'black' },
                    x: 0.5,
                    xanchor: 'center',
                    y: -0.2
                },
                margin: { t: 50, b: 40, l: 10, r: 10 },
                height: 500
            };

            const data = {
                values,
                labels,
                hole: 0.4,
                type: 'pie',
                textinfo: 'percent',
                textfont: { color: 'white', size: 12 },
                hoverlabel: { font: { color: 'white' } },
                hoverinfo: 'label+percent+name',
                name: 'Tỉ lệ<br>Đánh giá'
            };

            Plotly.newPlot(plotRef.current, [data], layout, { responsive: true });
        }
    }, [statisticsDoctorEvaluationDonut.data]);

    useEffect(() => {
        const handleResize = () => {
            if (plotRef.current) {
                Plotly.Plots.resize(plotRef.current);
            }
        };

        window.addEventListener('resize', handleResize);

        // Cleanup on unmount
        return () => {
            window.removeEventListener('resize', handleResize);
            if (plotRef.current) {
                Plotly.purge(plotRef.current);
            }
        };
    }, []);


    const plotRefPatientByDay = useRef(null);

    useEffect(() => {
        if (
            plotRefPatientByDay.current &&
            statisticsPatientByDay &&
            statisticsPatientByDay.data
        ) {
            const dates = statisticsPatientByDay.data.map((item) => item.date);
            const quantities = statisticsPatientByDay.data.map(
                (item) => item.totalQuantity
            );
            const times = statisticsPatientByDay.data.map((item) => item.totalTimes);
            const secs = statisticsPatientByDay.data.map((item) => item.totalSecs);

            const data = [
                {
                    x: dates,
                    y: quantities,
                    type: 'scatter',
                    mode: 'lines+markers',
                    name: 'Số lượng mỗi lần'
                },
                {
                    x: dates,
                    y: times,
                    type: 'scatter',
                    mode: 'lines+markers',
                    name: 'Số lần mỗi séc'
                },
                {
                    x: dates,
                    y: secs,
                    type: 'scatter',
                    mode: 'lines+markers',
                    name: 'Số séc mỗi buổi'
                }
            ];

            const layout = {
                title: 'Thống kê theo ngày',
                xaxis: { title: 'Ngày' },
                yaxis: { title: 'Giá trị' },
                legend: { orientation: 'h', x: 0.5, xanchor: 'center', y: -0.2 },
                margin: { t: 50, b: 40, l: 50, r: 30 },
                height: 400
            };

            Plotly.newPlot(plotRefPatientByDay.current, data, layout, {
                responsive: true
            });
        }
    }, [statisticsPatientByDay.data]);

    useEffect(() => {
        const handleResize = () => {
            if (plotRefPatientByDay.current) {
                Plotly.Plots.resize(plotRefPatientByDay.current);
            }
        };

        window.addEventListener('resize', handleResize);

        // Cleanup on unmount
        return () => {
            window.removeEventListener('resize', handleResize);
            if (plotRefPatientByDay.current) {
                Plotly.purge(plotRefPatientByDay.current);
            }
        };
    }, []);


    const handleApplyMethodDonut = (event, picker) => {
        setDatesMethodDonut({
            startDate: picker.startDate,
            endDate: picker.endDate
        });
        picker.element.val(
            `${picker.startDate.format(
                'DD/MM/YYYY HH:mm'
            )} - ${picker.endDate.format('DD/MM/YYYY HH:mm')}`
        );
    };
    const handleCancelMethodDonut = (event, picker) => {
        setDatesMethodDonut({
            startDate: null,
            endDate: null
        });
        picker.element.val('');
    };

    const isSameMonthRestriction = (date, otherDate) => {
        return (
            date.isSame(otherDate, 'month') && date.isSame(otherDate, 'year')
        );
    };

    const loadOptions = async (search, loadedOptions, { page }) => {
        const pageSize = 10;
        const res = await Get(ACCOUNT_API.GET_PAGING_ACCOUNT, null, {
            PageIndex: page,
            PageSize: pageSize,
            Role: role.Patient,
            Keyword: search // pass the input text to filter server-side
        });

        const data = res.data || [];
        const options = data.map((x) => ({
            label: `${x.fullName} - ${x.username}`,
            value: x.id
        }));

        // assume your API returns total count or a flag for more pages
        const hasMore = data.length === pageSize;
        return {
            options,
            hasMore,
            additional: { page: page + 1 }
        };
    };

    return (
        <div className="container-fluid">
            <div className="col-lg-6">
                <AsyncPaginate
                    name="accountPatientId"
                    id="accountPatientId"
                    placeholder="Chọn tài khoản"
                    value={accountPatientId.value}
                    loadOptions={loadOptions}
                    styles={styleSelectDefault}
                    isClearable
                    onChange={(selectedOption) => {
                        const event = {
                            target: {
                                name: 'accountPatientId',
                                value: selectedOption
                            }
                        };
                        setAccountPatientId(event);
                    }}
                    additional={{
                        page: 1
                    }}
                />
            </div>
            <div style={{ marginBottom: '1rem', marginTop: "20px" }} className="row">
                <div style={{ height: '100%' }} className="col-lg-12">
                    <Card>
                        <Card.Header style={{ fontSize: 25 }}>
                            Biểu đồ
                        </Card.Header>
                        <Card.Header>
                            <div className="col-lg-6">
                                <DateRangePicker
                                    onApply={handleApplyMethodDonut}
                                    onCancel={handleCancelMethodDonut}
                                    // onEvent={handleEvent}
                                    initialSettings={{
                                        // autoUpdateInput: false,
                                        locale: {
                                            format: 'DD/MM/YYYY HH:mm',
                                            cancelLabel: 'Xóa',
                                            customRangeLabel: 'Tùy chọn',
                                            applyLabel: 'Chọn',
                                            monthNames: monthNames
                                        },
                                        linkedCalendars: false,
                                        showDropdowns: true,
                                        ranges: rangeDateReport,
                                        timePicker: true,
                                        timePicker24Hour: true
                                        // startDate: moment(
                                        //     dates.startDate
                                        // ).format('MM/DD/YYYY'),
                                        // endDate: moment(
                                        //     dates.endDate
                                        // ).format('MM/DD/YYYY'),
                                    }}
                                >
                                    <input
                                        onChange={(e) => {
                                            if (e.target.value.length === 0) {
                                                setDatesMethodDonut({
                                                    startDate: null,
                                                    endDate: null
                                                });
                                            }
                                        }}
                                        defaultValue={`${moment(
                                            datesMethodDonut.startDate
                                        ).format('DD/MM/YYYY HH:mm')} - ${moment(
                                            datesMethodDonut.endDate
                                        ).format('DD/MM/YYYY HH:mm')}`}
                                        type="text"
                                        className="form-control"
                                        placeholder="Chọn khoảng thời gian"
                                    />
                                </DateRangePicker>

                            </div>


                        </Card.Header>
                        <Card.Body>
                            <div className="row">
                                <div className="col-lg-6">
                                    <div
                                        ref={plotRef}
                                        style={{ width: '100%' }}
                                    ></div>
                                </div>
                                <div className="col-lg-6">
                                    <div
                                        ref={plotRefPatientByDay}
                                        style={{ width: '100%' }}
                                    ></div>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
